// @flow
import { ItSendStatsActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    itSendStat: {},
    listaItSendStats: [],
    loading: false,
    error: false,
    formSubmited: false
};

type ItSendStatsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { itSendStat?: {} | null, listaItSendStats?: [] | null, loading?: boolean, +value ?: boolean };

const ItSendStats = (state: State = INIT_STATE, action: ItSendStatsAction): any => {
    // console.log(action);
    switch (action.type) {
        case ItSendStatsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ItSendStatsActionTypes.GET_IT_SEND_STAT: {
                    return {
                        ...state,
                        itSendStat: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ItSendStatsActionTypes.LIST_IT_SEND_STATS: {
                    return {
                        ...state,
                        listaItSendStats: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ItSendStatsActionTypes.IT_SEND_MAIL: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                    };
                }
                case ItSendStatsActionTypes.ADD_IT_SEND_STAT: {
                    return {
                        ...state,
                        itSendStat: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ItSendStatsActionTypes.UPDATE_IT_SEND_STAT: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ItSendStatsActionTypes.DELETE_IT_SEND_STAT: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ItSendStatsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ItSendStatsActionTypes.GET_IT_SEND_STAT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        itSendStat: {},
                        loading: false,
                    };
                }
                case ItSendStatsActionTypes.LIST_IT_SEND_STATS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaItSendStats: [],
                        loading: false,
                    };
                }
                case ItSendStatsActionTypes.IT_SEND_MAIL: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    };
                }
                case ItSendStatsActionTypes.ADD_IT_SEND_STAT: {
                    return {
                        ...state,
                        itSendStat: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ItSendStatsActionTypes.UPDATE_IT_SEND_STAT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case ItSendStatsActionTypes.DELETE_IT_SEND_STAT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case ItSendStatsActionTypes.GET_IT_SEND_STAT:
            return { ...state, error: false, loading: true };
        case ItSendStatsActionTypes.LIST_IT_SEND_STATS:
            return { ...state, error: false, loading: true };
        case ItSendStatsActionTypes.IT_SEND_MAIL:
            return { ...state, error: false, loading: true };
        case ItSendStatsActionTypes.ADD_IT_SEND_STAT:
            return { ...state, error: false, loading: true };
        case ItSendStatsActionTypes.UPDATE_IT_SEND_STAT:
            return { ...state, error: false, loading: true };
        case ItSendStatsActionTypes.DELETE_IT_SEND_STAT:
            return { ...state, error: false, loading: true };
        case ItSendStatsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                itSendStat: {},
                listaItSendStats: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default ItSendStats;
